import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSearch = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 23,
	height: 23,
	viewBox: "0 0 23 23",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	focusable: "false",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M8.61769 16.2354C12.8248 16.2354 16.2354 12.8248 16.2354 8.61769C16.2354 4.41056 12.8248 1 8.61769 1C4.41056 1 1 4.41056 1 8.61769C1 12.8248 4.41056 16.2354 8.61769 16.2354Z",
		stroke: "#6D6D6D",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M21 20.999L14.3563 14.3554",
		stroke: "#6D6D6D",
		strokeWidth: 2,
		strokeLinecap: "square",
		strokeLinejoin: "round"
	})]
});
export default SvgSearch;
